module.exports = __webpack_public_path__ + "static/media/21.d7261a9a.svg";